import styled from 'styled-components';
import {
  LogoutMobileAppModalContentProps,
  LogoutMobileAppModalStylesProps,
} from './LogoutModal.mobileApp';
import { AllieButton, AllieToolbar } from '../../../../components';

export const LogoutMobileAppModalStyled = styled.div<
  LogoutMobileAppModalStylesProps & { zIndex?: number }
>`
  display: ${({ isOpen }) => (isOpen ? 'flex' : 'none')};
  overflow: hidden;
  flex-direction: column;
  transition: top 0.5s ease;
  background-color: ${({ backgroundColor }) =>
    backgroundColor ? `var(--allie-color-${backgroundColor})` : 'var(--allie-color-neutral-5)'};
  position: fixed; /* Cambiar de absolute a fixed */
  z-index: ${({ zIndex }) => zIndex};
  border-radius: var(--allie-radius-3xl) var(--allie-radius-3xl) 0 0;
  z-index: 1000;

  /* SOLUCIÓN: Usar safe areas */
  top: var(--safe-area-inset-top, 0px);
  left: var(--safe-area-inset-left, 0px);
  right: var(--safe-area-inset-right, 0px);
  bottom: var(--safe-area-inset-bottom, 0px);

  /* Calcular dimensiones considerando safe areas */
  width: calc(100vw - var(--safe-area-inset-left, 0px) - var(--safe-area-inset-right, 0px));
  height: calc(100vh - var(--safe-area-inset-top, 0px) - var(--safe-area-inset-bottom, 0px));

  ${({ isOpen }) => isOpen && 'transform: translateY(0);'}
`;

export const LogoutMobileAppModalHeader = styled.header<{ isAndroid?: boolean }>`
  border-bottom: none;
  padding-top: ${({ isAndroid }) => (isAndroid ? '24px' : '0')};
`;

export const AllieToolbarMobileAppModalStyled = styled(AllieToolbar)`
  --border-color: var(--allie-color-neutral-20);
  --border-width: 0;
  --background: var(--allie-color-neutral-10);
  > div {
    display: flex;
    align-items: center;
    gap: var(--allie-spacing-md);
  }
`;

export const LogoutMobileAppModalContent = styled.div<LogoutMobileAppModalContentProps>`
  overflow-y: ${({ overflowY }) => overflowY};
  flex-grow: 1;
  ${({ hide }) => hide && 'display: none;'}
  padding: var(--allie-spacing-3xl);
  display: flex;
  flex-direction: column;
  gap: var(--allie-spacing-3xl);

  /* Ocultar scrollbar en todos los navegadores */
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */

  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera */
    width: 0;
    height: 0;
  }
`;

export const StyledRoundButton = styled(AllieButton)`
  --background: #e4e4e7 !important;
  --background-hover: #d4d4d8 !important;
  --background-activated: #d4d4d8 !important;
  --background-focused: #d4d4d8 !important;
  --border-width: 0px !important;
  --border-style: none !important;
  --border-radius: 36px !important;
  --padding-top: 8px;
  --padding-bottom: 8px;
  --padding-start: 8px;
  --padding-end: 8px;
  --box-shadow: none;
  width: 36px;
  height: 36px !important;
  min-width: 36px;
  min-height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;

  overflow: visible;

  &::part(native) {
    border: none;
    padding: 0;
    min-height: 36px;
    overflow: visible;
  }

  &:active {
    transform: scale(0.95);
  }
`;
